import { useQuery } from 'react-query';

import { ProductService } from '@Services/Product';

export const useProductGetPalletOccupation = () => {
  return useQuery([ProductService.endpoint, 'pallet'], () => ProductService.getPalletOccupation());
};
